import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "../../lib/api";
import { ActionButton } from "../common";

export const WorkOrderEmailStatus = ({ order, manager }) => {
  const [notice, setNotice] = useState(null), [error, setError] = useState(""), [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { setNotice((await api.get(`/fleet/work-orders/${order.id}/email-status`)).data); setError(""); }
    catch (e) { setError(errMsg(e)); }
  }, [order.id]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!notice || !["queued", "sending"].includes(notice.status)) return;
    const timer = setInterval(load, 2000); return () => clearInterval(timer);
  }, [notice, load]);
  const retry = async () => {
    setBusy(true); setError("");
    try { await api.post(`/fleet/work-orders/${order.id}/notify-shop-managers`); await load(); }
    catch (e) { setError(errMsg(e)); }
    finally { setBusy(false); }
  };
  return <section data-testid="wo-driver-email-panel" className="rounded border border-slate-300 bg-white p-3 text-sm space-y-2">
    <p data-testid="wo-driver-request-meta">Requested by driver: {order.requestor_name} · Asset assignment required before starting work</p>
    {notice && <p data-testid="wo-driver-email-status">Shop Manager email: {notice.status.replaceAll("_", " ")} · {notice.accepted_count} accepted by provider</p>}
    {error && <p role="alert" data-testid="wo-driver-email-error" className="text-red-700">{error}</p>}
    {manager && notice && ["failed", "partial", "no_recipients"].includes(notice.status) && <ActionButton testId="wo-driver-email-retry" type="button" variant="secondary" disabled={busy} onClick={retry}>Retry Unsent Notifications</ActionButton>}
  </section>;
};
